// extracted by mini-css-extract-plugin
export default {"switch":"Toggle_switch__m6xpZ","slider":"Toggle_slider__K6uxl","checked":"Toggle_checked__gxJjs","small":"Toggle_small__yL99b","disabled":"Toggle_disabled__UZa+B"};